import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const NoSelectedResult = () => (
  <div className={cx('NoSelectedResult')}>
    <p className={cx('txt')}>
      선택 항공편 결과없음 - 전체 항공편을 재조회한 결과입니다.
    </p>
  </div>
);

export default NoSelectedResult;
